module.exports = __webpack_public_path__ + "img/card5.829d9e35.png";